export default "__VITE_ASSET__62b5e666__"